var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "education",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11827",
    "data-name": "Path 11827",
    d: "M395.24,121.554a1.875,1.875,0,0,0,3.75,0v-7.73l-3.75,1.371Z",
    transform: "translate(-345.835 -99.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11828",
    "data-name": "Path 11828",
    d: "M88.047,10.685l19.274,7.049a1.875,1.875,0,0,0,1.288,0L127.9,10.686a1.879,1.879,0,0,0,0-3.522L108.615.114a1.874,1.874,0,0,0-1.288,0L88.048,7.163A1.879,1.879,0,0,0,88.047,10.685Z",
    transform: "translate(-75.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11829",
    "data-name": "Path 11829",
    d: "M63.89,282.707a6.367,6.367,0,0,0-6.36-6.36c-8.426.32-8.424,12.4,0,12.72A6.367,6.367,0,0,0,63.89,282.707Z",
    transform: "translate(-44.81 -241.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11830",
    "data-name": "Path 11830",
    d: "M372.371,282.707a6.367,6.367,0,0,0-6.36-6.36c-8.426.32-8.424,12.4,0,12.72A6.367,6.367,0,0,0,372.371,282.707Z",
    transform: "translate(-314.731 -241.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11831",
    "data-name": "Path 11831",
    d: "M205.12,282.707a6.367,6.367,0,0,0,6.36,6.36c8.426-.32,8.424-12.4,0-12.72A6.367,6.367,0,0,0,205.12,282.707Z",
    transform: "translate(-179.48 -241.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11832",
    "data-name": "Path 11832",
    d: "M362.44,378.107a12.645,12.645,0,0,0-6.828,1.993,16.344,16.344,0,0,1,4.006,10.727v4.017h13.668a1.875,1.875,0,0,0,1.875-1.875v-2.142A12.734,12.734,0,0,0,362.44,378.107Z",
    transform: "translate(-311.16 -330.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11833",
    "data-name": "Path 11833",
    d: "M165.451,378.107a12.782,12.782,0,0,0-12.814,12.72v4.017h25.628v-4.017A12.782,12.782,0,0,0,165.451,378.107Z",
    transform: "translate(-133.557 -330.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11834",
    "data-name": "Path 11834",
    d: "M12.72,378.107A12.734,12.734,0,0,0,0,390.827v2.142a1.875,1.875,0,0,0,1.875,1.875H15.33v-4.017a16.347,16.347,0,0,1,4.081-10.814,12.644,12.644,0,0,0-6.69-1.906Z",
    transform: "translate(0 -330.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11835",
    "data-name": "Path 11835",
    d: "M184.5,147.544v-6.707l-9.992,3.652a5.628,5.628,0,0,1-3.865,0l-9.977-3.649v6.707a1.875,1.875,0,0,0,1.231,1.761l10.035,3.67a1.876,1.876,0,0,0,1.288,0l10.048-3.672A1.875,1.875,0,0,0,184.5,147.544Z",
    transform: "translate(-140.584 -123.232)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationWhiteIcon);
export default __webpack_public_path__ + "static/media/education_white_icon.b19e6b1342134f647a0c91439ff4d092.svg";
export { ForwardRef as ReactComponent };